import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type networkSettingsContentDetailsInitialStateType = {
  networkSettingsPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: networkSettingsContentDetailsInitialStateType = {
  networkSettingsPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = 'network-settings.json'

export const getNetworkSettingsContent = createAsyncThunk(
  "get/networkSettings-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const networkSettingsContentDetailSlice = createSlice({
  name: "networkSettings-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNetworkSettingsContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNetworkSettingsContent.fulfilled, (state, action) => {
      state.networkSettingsPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getNetworkSettingsContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "network settings AEM Content",
        action.error?.message,
        action?.type
      );
      state.networkSettingsPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const {} = networkSettingsContentDetailSlice.actions;
export default networkSettingsContentDetailSlice.reducer;
